import React, { useMemo } from "react";
import { money } from "./cotizacionConstants";

export default function TotalsCard({
  datos,
  subtotalBase,
  iva,
  total,
  ivaPct,
  divisa,
}) {
  const { subtotal, subtotalConDesc, tipoLabel, discountAmount } =
    useMemo(() => {
      const subtotal = Number(subtotalBase || 0);
      const subtotalConDesc = Math.max(
        0,
        Number(total || 0) - Number(iva || 0),
      );

      const items = Array.isArray(datos) ? datos : [];
      const itemsConDesc = items.filter((x) => Number(x?.descuento || 0) > 0);

      if (itemsConDesc.length === 0) {
        return {
          subtotal,
          subtotalConDesc,
          tipoLabel: null,
          discountAmount: 0,
        };
      }

      const tipos = new Set(itemsConDesc.map((x) => x?.tipoDescuento || "%"));
      const tipoLabel = tipos.size === 1 ? Array.from(tipos)[0] : "Mixto";

      const discountAmount = Math.max(
        0,
        Number(subtotal || 0) - Number(subtotalConDesc || 0),
      );

      return { subtotal, subtotalConDesc, tipoLabel, discountAmount };
    }, [datos, iva, subtotalBase, total]);

  return (
    <div className="cf-totals-card">
      <div className="cf-totals-lines">
        <div className="cf-tline">
          <span>Subtotal</span>
          <span>{money(subtotal)}</span>
        </div>

        {tipoLabel ? (
          <div className="cf-tline">
            <span>{`Descuento (${tipoLabel})`}</span>
            <span className="cf-tline-danger">{`- ${money(discountAmount)}`}</span>
          </div>
        ) : null}

        <div className="cf-tline">
          <span>Subtotal con descuento</span>
          <span>{money(subtotalConDesc)}</span>
        </div>

        <div className="cf-tline">
          <span>
            IVA ({Number.isFinite(Number(ivaPct)) ? Number(ivaPct) : 16}%)
          </span>
          <span>{`+ ${money(iva)}`}</span>
        </div>

        <div className="cf-tsep" />

        <div className="cf-ttotal">
          <span>Total</span>
          <span className="cf-ttotal-right">
            <span className="cf-ttotal-cur">{divisa}</span>
            <span className="cf-ttotal-val">{money(total)}</span>
          </span>
        </div>
      </div>
    </div>
  );
}
